<template>
  <div v-show="isShowHeader" :class="['page-header', layout, pageWidth]">
    <div class="page-header-wide HEADER">
      <div class="breadcrumb">
        <Breadcrumb />
      </div>
      <div class="detail">
        <div class="main">
          <div class="row">
            <h1 v-if="showPageTitle && title" class="title">{{ titleName || title }}</h1>
            <div class="action">
              <slot name="action"></slot>
            </div>
          </div>
          <div class="row">
            <div v-if="this.$slots.content" class="content">
              <div v-if="avatar" class="avatar">
                <a-avatar :src="avatar | filterUrl" :size="72" />
              </div>
              <slot name="content"></slot>
            </div>
            <div v-if="this.$slots.extra" class="extra">
              <slot name="extra"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from './Breadcrumb.vue'
import $Bus from '@/pages/projectImpl/js/eventBus'

export default {
  name: 'PageHeader',
  components: { Breadcrumb },
  props: {
    title: {
      type: [String, Boolean],
      required: false,
    },
    breadcrumb: {
      type: Array,
      required: false,
    },
    logo: {
      type: String,
      required: false,
    },
    avatar: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState('setting', ['layout', 'showPageTitle', 'pageWidth']),
  },

  data() {
    return {
      titleName: '',
      myBreadcrumb: [],
      isShowHeader: true,
    }
  },
  created() {
    $Bus.$on('pageHeaderTitle', (str) => {
      this.$set(this, 'titleName', str)
    })
    $Bus.$on('pageHeaderBreadcrumb', (arr) => {
      // if (Array.isArray(arr)) this.myBreadcrumb = arr
    })
    $Bus.$on('closePageHeader', (bool) => {
      this.isShowHeader = !bool
    })
  },
  mounted() {
    this.$router.beforeEach((to, from, next) => {
      if (to.fullPath != from.fullPath) {
        this.titleName = ''
        this.isShowHeader = true
      }
      next()
    })
  },
}
</script>

<style lang="less" scoped>
@import 'index';
.HEADER {
  position: relative;
}
</style>
